/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="m16.1549 14.1614-.0335.02c-.02.7521-.3366 1.4016-.9337 1.9432-.5925.5373-1.3615.8527-2.2976.9594v.1626c0 .4897-.3992.8867-.8917.8867-.4925 0-.8918-.397-.8918-.8867v-.2465c-.788-.1794-1.4633-.5174-2.0288-1.0095-.5883-.5119-.9994-1.1067-1.2288-1.7777a.1332.1332 0 0 1 .0879-.1705l1.73-.5238a.1342.1342 0 0 1 .1638.0788c.1917.4857.5063.879.9474 1.1879.4358.3051.967.4607 1.5942.4607.5073 0 .9072-.112 1.2104-.3248.3082-.2164.444-.4518.444-.7124 0-.206-.0801-.3858-.2452-.5444-.1661-.1595-.4618-.3137-.8967-.4473l-2.3734-.7436c-.6678-.2059-1.2032-.5206-1.5993-.9416-.4015-.4268-.602-.9449-.602-1.5527 0-.7054.2773-1.3213.8216-1.8422.519-.4969 1.184-.7997 1.9814-.9135v-.47c0-.4898.3993-.8868.8918-.8868.4925 0 .8917.397.8917.8867v.5433c.702.1518 1.3168.431 1.8476.8443.5558.4328.9494.9365 1.174 1.5119l.0529.1354-1.9379.5633-.0504-.0986c-.1817-.3553-.4674-.6412-.8575-.863-.3877-.2203-.8262-.3316-1.3188-.3316-.4231 0-.7582.0928-1.0093.267-.2531.1755-.3654.3777-.3654.602 0 .1661.0605.3065.1873.4278.1305.125.3354.2333.6265.3173l.0038.0012 2.3143.7434c.8163.2488 1.4533.5664 1.9018.9583.4647.4061.6894.9832.6894 1.7105v.0755Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1.9267 1.7208C1.5972.9016 2.1997 0 3.0869 0h14.9558c1.9955 0 3.7899 1.2081 4.531 3.0506a9.3539 9.3539 0 0 1-.0882 7.1958l-.5546 1.2867a12.7156 12.7156 0 0 0-.3796 9.0773l.4363 1.3017C22.3319 22.9393 21.5631 24 20.4743 24H6.3311c-2.243 0-4.2342-1.4272-4.9435-3.5431a12.2926 12.2926 0 0 1 .367-8.775l.0642-.1488c1.3429-3.116 1.374-6.6647.1079-9.8123ZM3.6674 12.321C5.0784 9.047 5.2369 5.3688 4.1621 2h13.8806c1.1731 0 2.228.7102 2.6637 1.7934a7.3645 7.3645 0 0 1-.0695 5.6652l-.5546 1.2867a14.7058 14.7058 0 0 0-.439 10.4976l.2538.7571H6.3311c-1.3772 0-2.6-.8764-3.0354-2.1756a10.3027 10.3027 0 0 1 .3076-7.3546l.0641-.1488Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'MenuBilling'
);
